import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

import { header } from "./header";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnApp_emaki } from "../components/vnApp_emaki";
import { content_value_reporting_template } from "../components/templates/content_value_reporting_template";

declare var ko: any;
declare var page: any;

export class content_value_reporting extends vnModule_knockoutJS {
    protected contentValueReporting: content_value_reporting_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected contentValueHandler : XMLHttpRequestHandler;

    protected pagination: pagination_template;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected timer;

    protected getModuleName(): string {
        return "content_value_reporting";
    }

    buildContent(): Array<Element> {
        this.contentValueReporting = new content_value_reporting_template("list",this.viewModel,this);
        this.template = this.contentValueReporting;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Content Value Reporting");

        let app: vnApp_emaki = <vnApp_emaki>this.getVnAppZone().getApp();

        return [this.contentValueReporting.build()];
    }

    public fillPage(): void {
        if(this.getVnAppZone().app.params.idBrand){
            this.contentValueReporting.setBrand(this.getVnAppZone().app.params.idBrand);
        }
        this.getFilterData();
        this.filterByUrl();
        //this.getContentValueData();
        this.contentValueReporting.buildDatePickerCalendar();   
    }

    private getContentValueData(): void {
        if (this.contentValueHandler) {
            this.contentValueHandler.cancelAndReset();
        }
        this.loadingIn(this.contentValueReporting.builtTemplate.children.namedItem("w-dashboard"));
        let brand = this.getVnAppZone().app.params.idBrand;
        let usrReq_url: string = "/api/brand/" + brand +"/sensai/get-content-value-report/get/";
        if(!brand){
            usrReq_url = "/api/sensai/get-content-value-report/get/";
        }
        
        let usrReq_params: Array<Array<string>> = [];
        this.contentValueHandler = new XMLHttpRequestHandler(usrReq_url,usrReq_params,this);

        this.contentValueHandler.mode = XMLHttpRequestHandler_requestType.GET;
        this.contentValueHandler.onReadyStateFunction =this.onGetContentValueDataRequestReturn;
        
        this.contentValueHandler.execute();
    }
    protected onGetContentValueDataRequestReturn(req, obj) {
        return ()=> {
            obj.manageResponse(req, obj, () => {
                let responseParsed = JSON.parse(req.request.response);
                let contentValueChartData = obj.prepareContentValueChartData(responseParsed.contentValueReport);
                let contentValueCharEngagementData = obj.prepareContentValueEngagementChartData(responseParsed.contentValueEngagementReport);                
                obj.contentValueReporting.setContentValueReport(contentValueChartData);
                obj.contentValueReporting.setContentValueEngagementReport(contentValueCharEngagementData);
                obj.contentValueReporting.setContentSuggestionsUsage(responseParsed.contentSuggestionsUsage);
                obj.contentValueReporting.setContentSuggestionUsageReport(responseParsed.contentSuggestionUsageOnAvgTime);
                obj.contentValueReporting.setContentSuggestionsCountByBrand(responseParsed.contentSuggestionsCountByBrand);
            });

            obj.loadingOut(obj.contentValueReporting.builtTemplate.children.namedItem("w-dashboard"));
        };
    }

    public prepareContentValueChartData(responseParsed) {
        const chartData = [];
        
        responseParsed.forEach((item) => {
            let existingGroup = chartData.find(group => group.category === item.groupName);
            
            if (!existingGroup) {
                existingGroup = { category: item.groupName, red: 0, orange: 0, silver: 0, gold: 0 };
                chartData.push(existingGroup);
            }
            
            if (item.badge === 'red') {
                existingGroup.red = item.badgeCount;
            } else if (item.badge === 'orange') {
                existingGroup.orange = item.badgeCount;
            } else if (item.badge === 'silver') {
                existingGroup.silver = item.badgeCount;
            } else if (item.badge === 'gold') {
                existingGroup.gold = item.badgeCount;
            }
        });
        
        return chartData;
    }

    public prepareContentSuggestionsUsage(responseParsed) {
        
        const chartData = [];

        responseParsed.forEach((item) => {
            let existingGroup = chartData.find(group => group.category === item.groupName);
            
            if (!existingGroup) {
                existingGroup = { category: "With Suggestions", count: item.percentageWithSuggestions, color:"#4CAF50"};
                chartData.push(existingGroup);
            }
        });
        return chartData;
    }

    public prepareContentValueEngagementChartData(responseParsed) {

        const chartData = [];

        responseParsed.forEach((item) => {
            let existingGroup = chartData.find(group => group.category === item.groupName);

            if(!existingGroup) {
                existingGroup = { category: item.badge, avgTimeOnPage: 0};
                chartData.push(existingGroup);
            }

            if(item.badge === 'red') {
                existingGroup.avgTimeOnPage = item.avgTimeOnPage;
            } else if(item.badge === 'orange') {
                existingGroup.avgTimeOnPage = item.avgTimeOnPage;
            } else if(item.badge === 'silver') {
                existingGroup.avgTimeOnPage = item.avgTimeOnPage;
            } else if(item.badge === 'gold') {
                existingGroup.avgTimeOnPage = item.avgTimeOnPage;
            }
        });

        return chartData;
    }

    public getFilterData(): void {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let brand = this.getVnAppZone().app.params.idBrand;
        let usrReq_url: string = "/api/brand/" + brand + "/articles/references";
        if(!brand){
            usrReq_url = "/api/sensai/get-content-value-references";
        }
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params,this);

        this.XHRHdl.onReadyStateFunction = this.onGetFilterDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetFilterDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();
            });

            // obj.loadingOut(
            //     obj.contentValueReporting.builtTemplate.children.namedItem(
            //         "w-dashboard"
            //     )
            // );
        };
    }

    protected updateFilters(responseParsed: any) {
        this.contentValueReporting.setGroupContentTypeFilterItems(responseParsed.groupContentTypes);        
    }

    protected filterList(){
        
        this.loadingIn(this.contentValueReporting.builtTemplate.children.namedItem("w-dashboard"));
        let brand = this.getVnAppZone().app.params.idBrand;
        let usrReq_url: string = "/api/brand/" + brand +"/sensai/get-content-value-report/get/";

        if(!brand){
            usrReq_url = "/api/sensai/get-content-value-report/get/";
        }
        // let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/sensai/get-content-value-report/get/';

        let subViewModel = this.contentValueReporting.getViewModelForRequest();
        this.timer = new Date().getTime();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetContentValueDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'content_value_reporting');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });

            obj.loadingOut(obj.contentValueReporting.builtTemplate.children.namedItem("w-dashboard"));
        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.contentValueReporting.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.contentValueReporting.setSearchPresets(response);
                //obj.filterList();
            });
        }
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterDateOnChange(){        
        this.filterList();
    }

    protected filterMultipleSelectorOnChange(){
        this.filterList();
    }

    protected filterByPresets(filters){
        this.contentValueReporting.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected setDefaultStatusFilters(){
        this.contentValueReporting.setDefaultDateRange();
    }
}



// WEBPACK FOOTER //
// ./js/modules/content_value_reporting.ts